import { Pipe, PipeTransform } from '@angular/core';
import { Reconciliation } from '../../../shared/services/buyer-api/survey.interface';

@Pipe({
  name: 'reconciliationStatus',
})
export class ReconciliationStatusPipe implements PipeTransform {
  transform(reconciliation: Reconciliation): string {
    if (
      reconciliation?.accept > 0 ||
      reconciliation?.reject > 0 ||
      reconciliation?.complete > 0
    ) {
      return 'YES';
    }

    return 'NO';
  }
}
